import React from 'react';

import clsxm from '@/lib/clsxm';

interface IProps {
  className?: string;
}

const VerticalDivider: React.FC<IProps> = ({ className }) => {
  return (
    <div
      className={clsxm(
        'border-l-1 mr-3 max-w-0 flex-1 rounded-b-xl rounded-t-xl border-4 border-b-0 border-r-0 border-t-0 border-ds-purple-50',
        className
      )}
    />
  );
};

export default VerticalDivider;
